import * as firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";

export interface Authenticator {
  init: () => Promise<void>;
}

export class StubAuthenticator implements Authenticator {
  init = async () => {
    await delay(500);
  };
}

const delay = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const firebaseConfig = {
  apiKey: "AIzaSyCx_UWk9mD_8FpB7n3H5FCQMBQKWO9IRkQ",
  authDomain: "scaevola-marketing.firebaseapp.com",
  projectId: "scaevola-marketing",
  storageBucket: "scaevola-marketing.appspot.com",
  messagingSenderId: "441857764199",
  appId: "1:441857764199:web:95d12e4f8408dddf24ddc2",
  measurementId: "G-HMMK844DK7",
};

export class FirebaseAuthenticator implements Authenticator {
  init = async () => {
    firebase.initializeApp(firebaseConfig);
    firebase.analytics();
  };
}



// WEBPACK FOOTER //
// ./src/utils/Auth.ts